import { Client, Deal, Invoice, KPI, PipelineStage } from './types';

// NOTE: Dashboard KPIs are now handled locally in Dashboard.tsx to support custom filtering and colors.
export const KPIS: KPI[] = []; 

export const CLIENTS: Client[] = [
  { id: '1', name: 'Alice Freeman', company: 'Nebula Studios', type: 'Client', mrr: 2500, owner: 'JD', lastTouch: '2h ago', status: 'Active', subscriptionMonth: 4 },
  { id: '2', name: 'Marcus Chen', company: 'Apex Logic', type: 'Lead', mrr: 0, owner: 'AS', lastTouch: '1d ago', status: 'New' },
  { id: '3', name: 'Sarah Jones', company: 'Bloom SaaS', type: 'Client', mrr: 4200, owner: 'JD', lastTouch: '3d ago', status: 'Attention', subscriptionMonth: 2 },
  { id: '4', name: 'David Wright', company: 'Wright & Co', type: 'Client', mrr: 1500, owner: 'AS', lastTouch: '5h ago', status: 'Onboarding', subscriptionMonth: 1 },
  { id: '5', name: 'Emma Watson', company: 'Tensor Flow', type: 'Lead', mrr: 0, owner: 'JD', lastTouch: 'Just now', status: 'New' },
  { id: '6', name: 'John Doe', company: 'Green Energy', type: 'Client', mrr: 3000, owner: 'JD', lastTouch: '1w ago', status: 'Active', subscriptionMonth: 12 },
  { id: '7', name: 'Lisa Ray', company: 'Urban Outfitters', type: 'Client', mrr: 2000, owner: 'AS', lastTouch: '2d ago', status: 'Active', subscriptionMonth: 3 },
  { id: '8', name: 'Michael Scott', company: 'Paper Co', type: 'Client', mrr: 1200, owner: 'JD', lastTouch: '4h ago', status: 'Attention', subscriptionMonth: 1 },
  { id: '9', name: 'Ryan Howard', company: 'WUPHF.com', type: 'Client', mrr: 500, owner: 'AS', lastTouch: '1d ago', status: 'Active', subscriptionMonth: 2 },
  { id: '10', name: 'Dwight Schrute', company: 'Beet Farm', type: 'Client', mrr: 4000, owner: 'JD', lastTouch: '3d ago', status: 'Active', subscriptionMonth: 5 },
];

export const DEALS: Deal[] = [
  { id: 'd1', title: 'Q3 Marketing Retainer', clientName: 'Nebula Studios', value: 12500, ownerInitial: 'J', daysOpen: 12, stageId: 'qualified' },
  { id: 'd2', title: 'Website Redesign', clientName: 'Apex Logic', value: 8500, ownerInitial: 'A', daysOpen: 4, stageId: 'new' },
  { id: 'd3', title: 'SEO Audit', clientName: 'Bloom SaaS', value: 3000, ownerInitial: 'J', daysOpen: 21, stageId: 'negotiation' },
  { id: 'd4', title: 'Mobile App MVP', clientName: 'StartUp Inc', value: 45000, ownerInitial: 'A', daysOpen: 2, stageId: 'proposal' },
  { id: 'd5', title: 'Brand Identity', clientName: 'Coffee House', value: 5000, ownerInitial: 'J', daysOpen: 45, stageId: 'won' },
];

export const PIPELINE_STAGES: PipelineStage[] = [
  { id: 'new', name: 'New', color: 'bg-slate-200' },
  { id: 'qualified', name: 'Qualified', color: 'bg-blue-200' },
  { id: 'proposal', name: 'Proposal', color: 'bg-purple-200' },
  { id: 'negotiation', name: 'Negotiation', color: 'bg-amber-200' },
  { id: 'won', name: 'Won', color: 'bg-emerald-200' },
];

// Using December 2025 dates for the Cashflow Forecast demo
export const INVOICES: Invoice[] = [
  { id: 'INV-2025-001', client: 'Nebula Studios', amount: 2500, dueDate: '2025-12-05', status: 'Paid' },
  { id: 'INV-2025-002', client: 'Bloom SaaS', amount: 4200, dueDate: '2025-12-10', status: 'Overdue' },
  { id: 'INV-2025-003', client: 'Wright & Co', amount: 1500, dueDate: '2025-12-15', status: 'Sent' },
  { id: 'INV-2025-004', client: 'Apex Logic', amount: 8500, dueDate: '2025-12-28', status: 'Draft' },
  { id: 'INV-2025-005', client: 'Tensor Flow', amount: 3200, dueDate: '2025-12-02', status: 'Paid' },
  { id: 'INV-2025-006', client: 'StartUp Inc', amount: 6000, dueDate: '2025-12-20', status: 'Sent' },
];

export const CASHFLOW_DATA = [
  { name: 'Week 1', cashIn: 5700, expected: 5700 },
  { name: 'Week 2', cashIn: 0, expected: 4200 },
  { name: 'Week 3', cashIn: 0, expected: 7500 },
  { name: 'Week 4', cashIn: 0, expected: 8500 },
];

export const PIPELINE_CHART_DATA = [
    { name: 'Onboard', value: 4 },
    { name: 'Active', value: 8 },
    { name: 'Review', value: 3 },
    { name: 'Renew', value: 4 },
    { name: 'Risk', value: 2 },
];